import { GeneratedPrivateLink } from '../../../../types/generated';

interface VideoPreviewProps {
  privateLink: GeneratedPrivateLink;
}

export const VideoPreview = ({ privateLink }: VideoPreviewProps) => {
  if (!privateLink.videoUrl) return null;

  const vimeoId = privateLink.videoUrl?.split('https://vimeo.com/').pop();

  const vimeoUrl = vimeoId
    ? `https://player.vimeo.com/video/${vimeoId}?muted=1&autoplay=1&loop=0`
    : null;

  if (!vimeoUrl) return null;
  return (
    <div className="aspect-[16/9] h-full w-full overflow-hidden rounded-sm bg-black">
      <iframe
        allow="autoplay; fullscreen; picture-in-picture; playsinline"
        className="rounded-sm shadow-[0_4px_100px_0_rgba(43,32,17,0.5)]"
        height="100%"
        src={vimeoUrl}
        title="Works preview video"
        width="100%"
      />
    </div>
  );
};
